export const isAndroidApp = () => {
    if (typeof window === 'undefined') return false;
    return window.navigator.userAgent.includes("CarriAppAndroid");
};
